import { render, staticRenderFns } from "./ChatMedia.vue?vue&type=template&id=a9493dda"
import script from "./ChatMedia.vue?vue&type=script&lang=ts"
export * from "./ChatMedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports